import './BetbookTicket.less';

import clsx from 'clsx';
import React from 'react';
import i18n from '../../../common/i18n';

import { SvgIcon } from '../../../icons/SvgIcon';
import { LoaderOrangeRings } from '../../loaders/loaderOrangeRings/LoaderOrangeRings';
import RadioButton from '../../forms/RadioButton';
import InfoCircleIcon from '../../../icons/svg/info-circle-icon-sv.svg';
import BetbookBetCounts from '../betbookBetCounts/BetbookBetCounts';
import BetbookPostEditorDate from '../betbookPostEditor/BetbookPostEditorDate';
import { formatMoneyAmount } from '../../../common/util';

const mapping = {
    Lost: 'lost',
    Won: 'winning',
    Win: 'winning',
    PaidOut: 'winning',
    Returned: 'returned',
    ReturnWon: 'returned',
    Cancelled: 'cancelled',
    Registered: 'registered',
    CashinPaidOut: 'winning',
    ReturnPaidOut: 'returned'
};

function getStatus(ticket) {
    return mapping[ticket?.displayStatus];
}

const BetbookTicket = ({
    label,
    ticket,
    onClose,
    pointer,
    selectable,
    otherClassName,
    selectedTicket,
    betbookWinLabel,
    openTicketDetail,
    showWrapperTitle,
    setSelectedTicket,
    ticketDetailOnWrapperClick,
    oldTicket = true,
    showHeader = false,
    showBetCount = false,
    showBetStatusCounts = true
}) => {
    const { hash, betCount, bets, betStatusCounts, odds, stake, submitDate, ticketId, win } = ticket || {};

    const selectedStatus = getStatus(ticket);
    const ticketDataLoaded = (betCount || bets || betStatusCounts) && stake && odds;

    function handleRadioClick(ticketId) {
        if (ticketId === selectedTicket) {
            return setSelectedTicket(null);
        }
        return setSelectedTicket(ticketId);
    }

    function handleInfoIconClick(e, hash) {
        e.stopPropagation();
        openTicketDetail(hash);
    }

    function handleTicketWrapperClick() {
        if (selectable) {
            if (ticketId === selectedTicket) {
                return setSelectedTicket(null);
            }
            return setSelectedTicket(ticketId);
        }
        if (ticketDetailOnWrapperClick && openTicketDetail) {
            openTicketDetail(hash);
        }
    }

    return ticketDataLoaded ? (
        <>
            {label && <div className="text-extra-bold c-default pt-30 mb-10">{label}</div>}
            <div
                title={showWrapperTitle ? i18n('nui.betbook.open-ticket-detail') : null}
                className={clsx(
                    'betbook-ticket br-b-default br-r-default br-t-default p-rel flex flex-col mb-10 ticket-status dark-tablet ticket-full-width',
                    selectedStatus || 'registered',
                    otherClassName,
                    {
                        'px-10': !oldTicket,
                        'px-15': oldTicket,
                        'py-10': showHeader,
                        'py-15': !showHeader,
                        pointer: pointer || selectable,
                        'bg-black-4': selectedTicket === ticketId || oldTicket
                    }
                )}
                onClick={handleTicketWrapperClick}
            >
                {showBetStatusCounts && betStatusCounts ? (
                    <BetbookBetCounts
                        betStatusCounts={betStatusCounts}
                        className={'flex justify-end p-abs full-width ticket-fade-in'}
                    />
                ) : null}

                {showHeader ? (
                    <div className="flex items-center justify-between full-width mb-10">
                        <div className="flex">
                            {selectable ? (
                                <RadioButton
                                    active={selectedTicket === ticketId}
                                    onClick={() => handleRadioClick(ticketId)}
                                />
                            ) : null}
                            <BetbookPostEditorDate date={submitDate} />
                        </div>
                        <button
                            className="flex"
                            onClick={e => handleInfoIconClick(e, hash)}
                            data-atid="betbook-post-editor-info-icon"
                            title={i18n('nui.betbook.open-ticket-detail')}
                        >
                            <InfoCircleIcon />
                        </button>
                    </div>
                ) : null}

                <div className={clsx('flex items-center', { 'ml-30': selectable })}>
                    {showBetCount ? (
                        <div
                            className={clsx(
                                'flex flex-col br-r-default ticket-fade-in pr-10 mr-10 tickets-right-margin tickets-right-padding',
                                { 'flex-1': oldTicket }
                            )}
                        >
                            <span className="uppercase c-black-40 ellipsis fs-11">
                                {i18n('nui.betbook.ticket.opportunities-count')}
                            </span>
                            <span className="text-extra-bold fs-13 c-default">{betCount || bets?.length}</span>
                        </div>
                    ) : null}
                    <div
                        className={clsx('flex ticket-fade-in flex-col pr-10 tickets-right-padding', {
                            'flex-1': oldTicket
                        })}
                    >
                        <span className="uppercase c-black-40 ellipsis fs-11">{i18n('nui.betbook.ticket.stake')}</span>
                        <span className="text-extra-bold fs-13 c-default no-wrap">
                            {formatMoneyAmount(stake, '\u20ac', 2)}
                        </span>
                    </div>
                    <div
                        className={clsx('flex flex-col br-l-default ticket-fade-in px-10 tickets-right-margin', {
                            'flex-1': oldTicket
                        })}
                    >
                        <span className="uppercase c-black-40 ellipsis fs-11">{i18n('nui.betbook.ticket.odds')}</span>
                        <span className="text-extra-bold fs-13 c-default no-wrap">{odds}</span>
                    </div>
                    <div
                        className={clsx('flex flex-col br-l-default ticket-fade-in px-20 tickets-right-margin', {
                            'flex-1': oldTicket
                        })}
                    >
                        <span className="uppercase c-black-40 ellipsis fs-11">
                            {betbookWinLabel || i18n('nui.betbook.ticket.eventual-win')}
                        </span>
                        <span className="text-extra-bold fs-13 c-default no-wrap">
                            {formatMoneyAmount(win, '\u20ac', 2)}
                        </span>
                    </div>
                    {onClose && (
                        <button onClick={onClose} className="betbook-ticket-remove-button p-abs br-default flex-center">
                            <SvgIcon imgId="close" sizeX="12px" sizeY="12px" className="c-white" />
                        </button>
                    )}
                </div>
            </div>
        </>
    ) : (
        <div
            className={clsx(
                'betbook-ticket ticket-suspense-height wave-animation br-b-default br-r-default br-t-default p-rel flex justify-center flex-col mb-10 ticket-status dark-tablet',
                selectedStatus || 'unknown',
                otherClassName,
                {
                    'px-10': !oldTicket,
                    'px-15': oldTicket,
                    'py-10': showHeader,
                    'py-15': !showHeader,
                    pointer: pointer || selectable,
                    'bg-black-4': selectedTicket === ticketId || oldTicket
                }
            )}
        >
            <LoaderOrangeRings />
        </div>
    );
};

export default BetbookTicket;
